import React from 'react';

export const Paragraph = (props) => {
    const {children = ""} = props;
    return (
        children.split ('\n').map((item, i) => <p key={i}>{item}</p>)
    );
};